<div class="border-top flex flex-wrap items-center justify-between gap-4 pt-6">
  <app-records-counter [numberOfRecords]="total"></app-records-counter>
  <ng-container *ngIf="dataExists && queryParams">
    <ngb-pagination
      class="-mb-4 mr-4"
      [disabled]="disabled"
      [collectionSize]="total"
      [(page)]="currentPage"
      [maxSize]="5"
      [pageSize]="queryParams.pageSize"
      [rotate]="true"
      [boundaryLinks]="false"
      (pageChange)="onPageChange($event)"
    ></ngb-pagination>
    <app-page-size-menu
      [disabled]="disabled"
      [values]="pageSizeValues"
      [(pageSize)]="queryParams.pageSize"
      (valueChanges)="onPageSizeChange($event)"
    ></app-page-size-menu>
  </ng-container>
  <button
    *ngIf="columns"
    type="button"
    [disabled]="disabled"
    ndt-secondary-button
    (click)="openColumnsManagement()"
    i18n
  >
    Zarządzaj kolumnami
  </button>
</div>
